let PageCategories = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.addForm();
        this.editForm();
        this.form();
        this.delete();
    },

    addForm: function () {
        let _this = this;

        const categoryForm = $('#categoryForm');

        if (categoryForm.length) {
            $(document).on('click', '.add-landing-page', () => {
                categoryForm.find('#categoryName').val('');
                categoryForm.resetForm();
            });
            let submitBtn = Ladda.create(categoryForm.find('[type=submit]')[0]);

            categoryForm.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        window.location.reload();
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }
    },

    editForm: function () {
        let _this = this;

        const categoryForm = $('#categoryForm');
        const categoryModal = $('#categoryModal');

        $('.edit-category').click(function () {
            const id = $(this).data('id');
            const row = $(this).closest('tr');

            $.get('/pages/categories/' + id + '/json', response => {
                if (response.success) {
                    const category = response.data;

                    categoryForm.find('#categoryName').val(category.name);
                    categoryForm.find('#categoryId').val(category.id);

                    categoryModal.modal('show');
                }
            });
        });
    },

    delete: function () {
        $('.delete-category').click(function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this category!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/pages/categories/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Category has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    form: function () {
        let _this = this;
        const categoryForm = $('#categoryForm');

        $('#landingPages').on('draw.dt', function () {
            _this.editForm();
            _this.delete();
        });
    },
};

$().ready(function () {
    window.PageCategories = PageCategories;
    window.PageCategories.init();
});
